import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import LogisticsImg from '../../../assets/logistics.jpg'; 
import './Logistic.css'
import amazon from '../../../assets/amazon.png'
import flipkart from '../../../assets/flipkart.png'
import meesho from '../../../assets/meesho.jpg'
import big from '../../../assets/bigbasket.png'
import express from '../../../assets/express.png'
import shree from '../../../assets/shree maruti.jpg'

export default function Logistic() {
  return (
    <Container fluid className="py-5 heading">
      <Row className="align-items-center">
        <Col lg={6} className="d-flex justify-content-center">
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img
              src={LogisticsImg}
              alt="Logistics"
              className="img-fluid shadow-lg rounded"
            />
          </motion.div>
        </Col>

        <Col lg={6}>
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h1>SHIVEK LOGISTICS</h1>
            <h2> Logistics Across India</h2>
            <p className="lead" style={{textAlign:'justify'}}>
            At Shivek Logistics, we are a leading logistics solutions provider known for our expertise in manpower supply and comprehensive logistics operations. With a strong presence across India and a dominant foothold in Madhya Pradesh, we have earned the trust of our clients for our reliability, efficiency, and high standards. 
            </p>
          </motion.div>
        </Col>
      </Row>

      <div className="my-5">
        <h2 className="text-center mb-4">Our Expertise</h2>
        <p>We understand the critical role logistics play in business operations. Our team is
equipped to manage all aspects of logistics, whether routine or complex. Here’s a
look at our core services:</p>
        <Row>
          <Col md={4}>
            <Card className="shadow-lg mb-4">
              <Card.Body>
                <Card.Title>Manpower Supply Services</Card.Title>
                <Card.Text>
                  We provide experienced field executives, team leaders, and area managers for efficient logistics operations, customer service, and warehouse management. 
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="shadow-lg mb-4">
              <Card.Body>
                <Card.Title>Vehicle Arrangement</Card.Title>
                <Card.Text>
                We have an extensive fleet of vehicles, ranging from trucks to specialized vehicles,
                ensuring your goods are safely and efficiently transported across the country.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="shadow-lg mb-4">
              <Card.Body>
                <Card.Title>EDSP (External Delivery Service Provider)</Card.Title>
                <Card.Text>
                  We offer robust EDSP solutions to ensure seamless last-mile delivery coordination.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="my-5">
        <h2 className="text-center mb-4">Why Choose Shivek Logistics?</h2>
        <Row>
          <Col md={4}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h4>Unmatched Expertise</h4>
              <p>With years of experience in the logistics industry, Shivek Logistics brings
unparalleled expertise to each project, cost-effective solutions
tailored to your needs.</p>
            </motion.div>
          </Col>

          <Col md={4}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h4>Pan-India Reach</h4>
              <p>With a strong presence across India, particularly in Madhya Pradesh, we are well-equipped to manage logistics operations nationwide.</p>
            </motion.div>
          </Col>

          <Col md={4}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h4>24/7 Availability</h4>
              <p>At Shivek Logistics, we know that logistics never sleep. We offer 24/7 availability,
              ensuring your operations run smoothly, no matter the time or day.</p>
            </motion.div>
          </Col>
        </Row>
      </div>

      <div className="my-5">
        <h2 className="text-center mb-4">Our Esteemed Clients</h2>
        <Row className="text-center">
          <Col md={2}>
            <img src={amazon} alt="Amazon" className="img-fluid1" />
          </Col>
          <Col md={2}>
            <img src={flipkart} alt="Flipkart" className="img-fluid1" />
          </Col>
          <Col md={2}>
            <img src={meesho}  alt="Meesho" className="img-fluid1" />
          </Col>
          <Col md={2}>
            <img src={big}  alt="Big Basket" className="img-fluid1" />
          </Col>
          <Col md={2}>
            <img src={express}  alt="Xpress Bees" className="img-fluid1" />
          </Col>
          <Col md={2}>
            <img src={shree}  alt="Shree Maruti" className="img-fluid1" />
          </Col>
        </Row>
      </div>
    </Container>
  );
}
